import React from "react";
import {
  Box,
  Text,
  Flex,
  Grid,
  Modal,
  Button,
  ModalBody,
  ModalFooter,
  ModalOverlay,
  ModalContent,
} from "@chakra-ui/react";

import moment from "moment";
import DataBox from "components/databox";

const ViewModal = ({ isOpen, onClose, bag }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent maxW={"800px"} borderRadius={16} padding={4}>
        <ModalBody>
          <Flex direction={"column"} gap={4}>
            <Flex direction={"column"} gap={4}>
              <Text
                fontFamily={"PlusJakartaSansSemiBold"}
                fontSize={"24px"}
                lineHeight={"32px"}
                textTransform={"capitalize"}
                color={"#000000"}
              >
                View Bag
              </Text>
              <Box height="1px" width="100%" bg="#8A8F9333" mx="auto" />
              <Flex direction={"column"} gap={2}>
                <Text
                  fontFamily={"PlusJakartaSansSemiBold"}
                  fontSize={"16px"}
                  lineHeight={"20px"}
                  textTransform={"capitalize"}
                  color={"#000000"}
                >
                  Details
                </Text>
                <Flex
                  border={"1px"}
                  borderColor={"#D9D9D9"}
                  borderStyle={"solid"}
                  padding={4}
                  borderRadius={6}
                >
                  <Grid
                    templateColumns="repeat(2, 1fr)"
                    rowGap={4}
                    columnGap={6}
                    flex={1}
                  >
                    <DataBox
                      label="Bag Send"
                      data={
                        bag?.bags && bag?.bags.length > 0
                          ? bag.bags.map((item) => item?.id).join(", ")
                          : "No Bags"
                      }
                    />
                    <DataBox
                      label={"Way Of Sending"}
                      data={
                        bag?.type === "drop-at-location"
                          ? "Drop At Location"
                          : bag?.type === "dhl"
                          ? "DHL"
                          : bag?.type
                      }
                    />
                    <DataBox label={"Location"} data={bag?.locationId?.name} />
                    <DataBox
                      label={"Created Date"}
                      data={moment(bag.date_created).format("DD/M/YYYY")}
                    />
                  </Grid>
                </Flex>
              </Flex>
            </Flex>
          </Flex>
        </ModalBody>
        <ModalFooter>
          <Flex w={"100%"} justify={"end"} gap={4}>
            <Button
              bg={"white"}
              border={"1px solid black"}
              color="#000000"
              borderRadius={"8px"}
              paddingInline={16}
              textTransform={"uppercase"}
              onClick={onClose}
            >
              Close
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ViewModal;
